import Vue from 'vue'
import Vuex from 'vuex'

import { auth } from './modules/auth';
import menu from './modules/menu';
import search from './modules/search';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    menu,
    search
  }
})
